import { useTranslation } from "react-i18next";
import TextInput from "../../components/inputs/textInput";
import { useFormik } from "formik";
import * as yup from "yup";
import { Link } from "react-router-dom";
import DateInput from "../../components/inputs/dateInput";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { AgentRegister } from "../../service/reducers/agents/auth/register";

const SignUpForm = () => {
  const { t } = useTranslation();
  const validationSchema = yup.object({
    email: yup.string().email(t("invalidEmail")).required(t("requiredField")),
    phone: yup.string().required(t("requiredField")),
    password: yup.string().min(8).required(t("requiredField")),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password"), null], t("passwordsMustMatch"))
      .required(t("requiredField")),
    first_name: yup.string().required(t("requiredField")),
    last_name: yup.string().required(t("requiredField")),
    birth_date: yup.date().required(t("requiredField")),
  });
  const [currentSignUpType, setCurrentSignUpType] = useState("agent");
  const dispatch = useDispatch();

  let signUpRequest;
  switch (currentSignUpType) {
    case "agent":
      signUpRequest = (data) => dispatch(AgentRegister(data));
      break;
    case "employee":
      signUpRequest = (data) => dispatch(AgentRegister(data));
      break;
    default:
      signUpRequest = null;
  }

  const formik = useFormik({
    initialValues: {
      password: "",
      password_confirmation: "",
      email: "",
      phone: "",
      first_name: "",
      last_name: "",
      birth_date: "",
    },
    validationSchema,
    onSubmit: (values) => {
      signUpRequest(values);
    },
  });

  console.log(formik.values, "vals");

  return (
    <form onSubmit={formik.handleSubmit}>
      <h1 className="my-4 text-3xl font-bold text-white">{t("signUp")}</h1>
      <section>
        <h1>{t("signUpAs")}</h1>
        <div className="flex items-center gap-2">
          {["agent", "employee"].map((type) => (
            <div key={type} className="flex items-center w-full mb-2">
              <button
                type="button"
                onClick={() => setCurrentSignUpType(type)}
                className={`bg-blue-500 w-full block text-white px-4 py-2 rounded ${
                  currentSignUpType === type ? "bg-blue-700" : ""
                }`}
              >
                {t(type)}
              </button>
            </div>
          ))}
        </div>
      </section>

      <TextInput
        label={t("email")}
        name="email"
        placeholder={t("email")}
        formik={formik}
      />

      <div className="inputs">
        <TextInput
          label={t("firstName")}
          name="first_name"
          placeholder={t("firstName")}
          formik={formik}
        />
        <TextInput
          label={t("lastName")}
          name="last_name"
          placeholder={t("lastName")}
          formik={formik}
        />
      </div>
      <div className="inputs">
        <TextInput
          formik={formik}
          name={"password"}
          label={t("password")}
          placeholder={"********"}
          type="password"
        />
        <TextInput
          formik={formik}
          name={"password_confirmation"}
          label={t("confirmPassword")}
          placeholder={"********"}
          type="password"
        />
      </div>
      <div className="inputs">
        <DateInput formik={formik} name={"birth_date"} label={t("dateOfBirth")} />
        <TextInput
          label={t("phone")}
          name="phone"
          placeholder={t("phone")}
          formik={formik}
        />
      </div>
      <p className="mt-4 text-sm">{t("byClickingSignUp")}</p>
      <p>
        <Link to="/terms-and-conditions" className="underline-link">
          {t("termsCondition")}
        </Link>{" "}
        <span>{t("and")}</span>{" "}
        <Link to="/privacy-policy" className="underline-link">
          {t("privacyPolicy")}
        </Link>
      </p>
      <button
        type="submit"
        className="w-full px-4 py-2 my-4 transition-colors rounded-lg bg-mainBlue hover:bg-blue-700"
      >
        {t("signUp")}
      </button>
    </form>
  );
};

export default SignUpForm;
